import React, { Component } from 'react';
import moment from 'moment-timezone'

class ReservationHistoryTable extends Component {
    constructor(props) {
        super(props);
        this.state = {};
    };

    getMoneyFormat(number) {
        return new Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(number)
    };

    render() {
        let reservas = []

        if (this.props.reservas) {
            reservas = this.props.reservas;
        };

        return (
            <div>
                <div className="table-responsiv column">
                    <table>
                        <thead className="" style={{ position: "sticky", top: "283px", zIndex: 1 }}>
                            <tr className="text-left">
                                <th className="">
                                    <div className="row">
                                        Área reservada &nbsp;
                                        <div className="align-center">
                                            {this.props.filterColumn.col === 'nombre' ? this.props.filterColumn.filt === 'asc' ?
                                                <i className="fas fa-sort-down" onClick={this.props.sortBy.bind(this, 'nombre')}></i>
                                                :
                                                <i className="fas fa-sort-up" onClick={this.props.sortBy.bind(this, 'nombre')}></i>
                                                :
                                                <i className="fas fa-sort" onClick={this.props.sortBy.bind(this, 'nombre')}></i>
                                            }
                                        </div>
                                    </div>
                                </th>
                                <th className="">
                                    <div className="row">
                                        Fecha &nbsp;
                                        <div className="align-center">
                                            {this.props.filterColumn.col === 'fecha_reserva' ? this.props.filterColumn.filt === 'asc' ?
                                                <i className="fas fa-sort-down" onClick={this.props.sortBy.bind(this, 'fecha_reserva')}></i>
                                                :
                                                <i className="fas fa-sort-up" onClick={this.props.sortBy.bind(this, 'fecha_reserva')}></i>
                                                :
                                                <i className="fas fa-sort" onClick={this.props.sortBy.bind(this, 'fecha_reserva')}></i>
                                            }
                                        </div>
                                    </div>
                                </th>
                                <th className="text-left">
                                    <div className="row">
                                        Vivienda &nbsp;
                                        <div className="align-center">
                                            {this.props.filterColumn.col === 'numero_registro' ? this.props.filterColumn.filt === 'asc' ?
                                                <i className="fas fa-sort-down" onClick={this.props.sortBy.bind(this, 'numero_registro')}></i>
                                                :
                                                <i className="fas fa-sort-up" onClick={this.props.sortBy.bind(this, 'numero_registro')}></i>
                                                :
                                                <i className="fas fa-sort" onClick={this.props.sortBy.bind(this, 'numero_registro')}></i>
                                            }
                                        </div>
                                    </div>
                                </th>
                                <th className="text-left">
                                    <div className="row">
                                        Horario &nbsp;
                                        <div className="align-center">
                                            {this.props.filterColumn.col === 'descripcion' ? this.props.filterColumn.filt === 'asc' ?
                                                <i className="fas fa-sort-down" onClick={this.props.sortBy.bind(this, 'descripcion')}></i>
                                                :
                                                <i className="fas fa-sort-up" onClick={this.props.sortBy.bind(this, 'descripcion')}></i>
                                                :
                                                <i className="fas fa-sort" onClick={this.props.sortBy.bind(this, 'descripcion')}></i>
                                            }
                                        </div>
                                    </div>
                                </th>
                                <th className="text-left">Estado</th>
                            </tr>
                        </thead>
                        <tbody>
                            {reservas.slice((this.props.page - 1) * this.props.pageLength, this.props.page * this.props.pageLength).map((reserva, key) => (
                                <tr key={key}>
                                    <td>{reserva.nombre}</td>
                                    <td>{moment(reserva.fecha_reserva).tz('GMT').format("DD/MM/YYYY")}</td>
                                    <td>{reserva.numero_registro}</td>
                                    <td>{reserva.descripcion}</td>
                                    <td className="tw-flex tw-py-2">
                                        {reserva.cancelada === "Cancelada" ? (
                                            <span className="tw-inline-flex tw-items-center tw-px-2 tw-py-1 tw-text-xs tw-font-semibold tw-leading-4 tw-text-red-600 tw-bg-red-100 tw-rounded-full tw-gap-1">
                                                <i className="fas fa-times-circle"></i>
                                                Cancelada
                                            </span>
                                        ) : reserva.cancelada === "Bloqueada" ? (
                                            <span className="tw-inline-flex tw-items-center tw-px-2 tw-py-1 tw-text-xs tw-font-semibold tw-leading-4 tw-text-gray-600 tw-bg-gray-100 tw-rounded-full tw-gap-1">
                                                <i className="fas fa-lock"></i>
                                                Bloqueada
                                            </span>
                                        ) : (
                                            <span className="tw-inline-flex tw-items-center tw-px-2 tw-py-1 tw-text-xs tw-font-semibold tw-leading-4 tw-text-green-600 tw-bg-green-100 tw-rounded-full tw-gap-1">
                                                <i className="fas fa-check-circle"></i>
                                                Completada
                                            </span>
                                        )}
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
        );
    }
}

export default ReservationHistoryTable;